module.exports = __webpack_public_path__ + "img/31210afc5e72cc81482a9f9d13172763.png";